import * as actionTypesNV02 from "./actionTypesNV02";
import { ProductGroupsResponse, AllWarehouseMetricsResponse, ProductResponse } from '../../models/NV02Lava';

// WAREHOUSE METRICS ACTIONS
export const fetchWarehouseMetricsRequest = (companyId: number) => ({
  type: actionTypesNV02.WAREHOUSE_METRICS_GET,
  payload: { companyId },
});

export const fetchWarehouseMetricsSuccess = (data: AllWarehouseMetricsResponse) => ({
  type: actionTypesNV02.WAREHOUSE_METRICS_GET_SUCCESS,
  payload: data,
});

export const fetchWarehouseMetricsFailure = (error: string) => ({
  type: actionTypesNV02.WAREHOUSE_METRICS_GET_FAILURE,
  payload: error,
});

export const fetchWarehouseMetricsReset = () => ({
  type: actionTypesNV02.WAREHOUSE_METRICS_RESET,
});

// PRODUCT METRICS ACTIONS
export const fetchProductMetricsRequest = (companyId: number, warehouse: number | null) => ({
  type: actionTypesNV02.PRODUCT_METRICS_GET,
  payload: { companyId, warehouse },
});

export const fetchProductMetricsSuccess = (data: ProductGroupsResponse) => ({
  type: actionTypesNV02.PRODUCT_METRICS_GET_SUCCESS,
  payload: data,
});

export const fetchProductMetricsFailure = (error: string) => ({
  type: actionTypesNV02.PRODUCT_METRICS_GET_FAILURE,
  payload: error,
});

export const fetchProductMetricsReset = () => ({
  type: actionTypesNV02.PRODUCT_METRICS_RESET,
});

// PRODUCT BY GROUP ACTIONS
export const fetchProductByGroupRequest = (companyId: number, group: number, warehouse: number | null) => ({
  type: actionTypesNV02.PRODUCT_BY_GROUP_GET,
  payload: { companyId, group, warehouse },
});
export const fetchProductByGroupSuccess = (data: ProductResponse ) => ({
  type: actionTypesNV02.PRODUCT_BY_GROUP_GET_SUCCESS,
  payload: data,
});
export const fetchProductByGroupFailure = (error: string) => ({
  type: actionTypesNV02.PRODUCT_BY_GROUP_GET_FAILURE,
  payload: error,
});
export const fetchProductByGroupReset = () => ({
  type: actionTypesNV02.PRODUCT_BY_GROUP_RESET,
});

// FETCH LAGER KODE ACTIONS
export const fetchLagerKodeRequest = () => ({
  type: actionTypesNV02.LAGERKODE_GET,
});

export const fetchLagerKodeSuccess = (data: any) => ({
  type: actionTypesNV02.LAGERKODE_GET_SUCCESS,
  payload: data,
});

export const fetchLagerKodeFailure = (error: string) => ({
  type: actionTypesNV02.LAGERKODE_GET_FAILURE,
  payload: error,
});

export const fetchLagerKodeReset = () => ({
  type: actionTypesNV02.LAGERKODE_RESET,
});
